export default __webpack_public_path__ + "_/shared_modules/base-layout/img/link_sent-f14a8c7c5f11bc3ac98860fb78018d07.svg";